"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KsysRequest_1 = require("../KsysRequest");

var Retrieve =
/** @class */
function (_super) {
  __extends(Retrieve, _super);

  function Retrieve() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getExplicitMethod = function () {
      return 'GET';
    };

    _this.getExplicitEndpoint = function () {
      return "/documents/retrieve/" + _this.token.value;
    };

    return _this;
  }

  Object.defineProperty(Retrieve.prototype, "endpointConfiguration", {
    get: function get() {
      return this.getEndpointConfiguration("documents", "Retrieve");
    },
    enumerable: true,
    configurable: true
  });
  return Retrieve;
}(KsysRequest_1.KsysRequest);

exports.Retrieve = Retrieve;